import CanvasDemo from '$lib/components/domain/CanvasDemo.svelte';
import ChartAnalysis from '$lib/components/domain/ChartAnalysis.svelte';
import Dashboard from '$lib/components/domain/Dashboard.svelte';
import LiveMonitor from '$lib/components/domain/LiveMonitor.svelte';
import Login from '$lib/components/domain/Login.svelte';
import NotFound from '$lib/components/domain/NotFound.svelte';
import RootRedirect from '$lib/components/domain/RootRedirect.svelte';
import Sessions from '$lib/components/domain/Sessions.svelte';
import VixAnalysis from '$lib/components/domain/VixAnalysis.svelte';
import { auth } from '$lib/stores/auth.svelte';
import { wrap } from 'svelte-spa-router/wrap';

// ============================================================
// Routes - Fase 1.
//
// Hash routing via svelte-spa-router. Rutas:
//   /          -> redirect a /dashboard (componente RootRedirect)
//   /login     -> Login (publica)
//   /dashboard -> Dashboard (protegido por wrap conditions)
//   *          -> NotFound
//
// Las rutas protegidas usan wrap() con una condition async que chequea
// auth.user. Si la condition falla, svelte-spa-router emite el evento
// conditionsFailed; lo capturamos en App.svelte para redirigir a /login.
//
// Cast a `any`: svelte-spa-router 4 todavia tiene types para Svelte <=4;
// los componentes Svelte 5 funcionan en runtime pero TS los rechaza como
// IsomorphicComponent. Mejor un solo cast aca que pelear con cada import.
// ============================================================

const requireAuth = async (): Promise<boolean> => {
  if (auth.loading) return false;
  return auth.user !== null;
};

// biome-ignore lint/suspicious/noExplicitAny: svelte-spa-router 4 types pre-Svelte 5
const routes: Record<string, any> = {
  '/': RootRedirect,
  '/login': Login,
  '/canvas-demo': CanvasDemo,
  '/dashboard': wrap({
    // biome-ignore lint/suspicious/noExplicitAny: ver nota arriba
    component: Dashboard as any,
    conditions: [requireAuth],
  }),
  '/sessions': wrap({
    // biome-ignore lint/suspicious/noExplicitAny: ver nota arriba
    component: Sessions as any,
    conditions: [requireAuth],
  }),
  // Live + Developer Monitor (Fase 4): mismo componente, distinta prop `mode`.
  '/live': wrap({
    // biome-ignore lint/suspicious/noExplicitAny: ver nota arriba
    component: LiveMonitor as any,
    conditions: [requireAuth],
    props: { mode: 'live' },
  }),
  '/developer': wrap({
    // biome-ignore lint/suspicious/noExplicitAny: ver nota arriba
    component: LiveMonitor as any,
    conditions: [requireAuth],
    props: { mode: 'developer' },
  }),
  // Chart Analysis (Fase 5): lista de sessions + candle/renko side-by-side.
  '/charts': wrap({
    // biome-ignore lint/suspicious/noExplicitAny: ver nota arriba
    component: ChartAnalysis as any,
    conditions: [requireAuth],
  }),
  // VIX Analysis (PR-3): P&L acumulado BT vs CBOE VIX correlation chart.
  '/vix': wrap({
    // biome-ignore lint/suspicious/noExplicitAny: ver nota arriba
    component: VixAnalysis as any,
    conditions: [requireAuth],
  }),
  '*': NotFound,
};

export default routes;
